export default function Hero() {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="inicio" className="hero">
      <div className="hero-diagonal" />
      <div className="hero-diagonal-2" />
      <div className="hero-red-bar" />

      <div className="hero-inner">
        <div className="hero-content">
          <p className="hero-overline">Tepatitlán de Morelos, Jalisco</p>
          <h1 className="hero-title">DISTRIBUIDORA</h1>
          <p className="hero-title-sub">de Aceros Económicos de Tepa</p>
          <p className="hero-subtitle">
            Tu distribuidor de acero en Tepatitlán con los mejores precios
            de la región. Viga, varilla, lámina, PTR, ángulos y más —
            para constructores, herreros y talleres.
          </p>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => scrollTo('productos')}>
              Ver Productos
            </button>
            <button className="btn btn-outline" onClick={() => scrollTo('contacto')}>
              Contáctanos
            </button>
          </div>
        </div>
      </div>

      <div className="hero-stats">
        <div className="hero-stats-inner">
          <div className="hero-stat">
            <span className="stat-number">+3</span>
            <span className="stat-label">Años de experiencia</span>
          </div>
          <div className="hero-stat">
            <span className="stat-number">+800</span>
            <span className="stat-label">Clientes satisfechos</span>
          </div>
          <div className="hero-stat">
            <span className="stat-number">10+</span>
            <span className="stat-label">Tipos de productos</span>
          </div>
        </div>
      </div>
    </section>
  );
}
